import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Card, Typography, Input, Dropdown, Menu,Row, Col, Divider, List } from 'antd';
import { DatePicker,Form, Layout, Button, Select, Radio} from 'antd';

import { pageHeaderStyle, pageTitle, cardHeaderStyle } from '../util/Style';
import { DownOutlined} from '@ant-design/icons';


import { AgGridReact } from 'ag-grid-react';

import PatientDetailsStore from '../stores/PatientDetailsStore';

const { Title } = Typography;
const { Option } = Select;
const { Sider, Content, Header, Footer } = Layout;
const { TextArea } = Input;

const height = window.innerHeight * .80;

class PatientTestUI extends Component {
    
    constructor(props) {
        super(props);
        this.store = new PatientDetailsStore();
    }
    
    onSelfButtonClick = () => {
        this.store.type = "self";
    }

    onLabButtonClick = () => {
        this.store.type = "lab";
    }
    
    onLabMenuClick = ({ key }) => {
        this.store.updateSelectedLab( key );
    };
    
    onDocMenuClick = ({ key }) => {
        this.store.updateSelectedDoctor( key );
    };
    
    deleteSelectedTestFromList = (event) => {
        
        this.store.deleteSelectedTest(event.rowIndex);
    }
    
    onSuggestedPatientSelect = (event) => {
        this.store.updatePatient(this.store.suggestedPatientResults[event.rowIndex]);
        this.store.patientSelected = true;
        this.store.clearSuggestedPatientResults();
    }
    
    onSuggestedTestSelect = (event) => {
        this.store.updateSelectedTestList(event.rowIndex);
    }
    
    onSearchPatientSuggestedList = (event) => {
        console.log(event);
        this.store.searchPatientList(event.target.value);
    }

    onSearchTestSuggestedList = (event) => {
        console.log(event);
        this.store.searchTestList(event.target.value);
    }
    
    onGenderRadioSelection = (option) => {
        this.store.patientDetails.gender = option.target.value;
    }

    onDobSelected = (value,dateString) => {
        this.store.patientDetails.dob = dateString;
    }

    onGenderSelect = (option,value) => {
        this.store.patientDetails.gender = option;
    }

    onAddressEntered = (option) => {
        console.log("option"+option);
        this.store.patientDetails.address = option;
        console.log("adress" + this.store.patientDetails.address);
    }

    dropDownLabMenuView = () => {    
        return (
            <Menu onClick={this.onLabMenuClick}>
                {
                    this.store.labsList.map((lab,index) => (
                        <Menu.Item key={index}>
                            { lab }
                        </Menu.Item>
                    ))
                } 
            </Menu>
        )   
    }

    dropDownDocMenuView = () => {    
        return (         
            <Menu onClick={this.onDocMenuClick}>
                {
                    this.store.doctorsList.map((doc,index) => (
                        <Menu.Item key={index}>
                            { doc }
                        </Menu.Item>
                    ))
                } 
            </Menu>
        )    
    }
    
    dropDownLab = () => {   
        return (
            this.store.selectedLab == '' ?
            <Dropdown overlay={this.dropDownLabMenuView()} disabled={this.store.type == 'self'}>
                <a 
                    className="ant-dropdown-link" 
                    onClick={e => e.preventDefault()}>
                    Select Lab <DownOutlined />
                </a>
            </Dropdown> 
            :  <Dropdown overlay={this.dropDownLabMenuView()} >
                    <a 
                        className="ant-dropdown-link" 
                        onClick={e => e.preventDefault()}>
                        {this.store.selectedLab} <DownOutlined />
                    </a>
                </Dropdown>
        )
    }
    
    dropDownDoctor = () => {
        return (
            this.store.selectedDoctor == '' ?
            <Dropdown overlay={this.dropDownDocMenuView()} disabled = {this.store.type == 'lab'} >
                <a 
                    className="ant-dropdown-link" 
                    onClick={e => e.preventDefault()}>
                    Select Doctor <DownOutlined />
                </a>
            </Dropdown> 
            :  <Dropdown overlay={this.dropDownDocMenuView()} >
                    <a 
                        className="ant-dropdown-link" 
                        onClick={e => e.preventDefault()}>
                        {this.store.selectedDoctor} <DownOutlined />
                    </a>
                </Dropdown>
        )
    }

    patientSourceView = () => {
        return (
            <>
                <Header style={{backgroundColor: '#f7faff'}} >
                    
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={6}>
                        <div >
                            <Button onClick={() => this.onSelfButtonClick()}> Self </Button>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <div >
                            <Button onClick={() => this.onLabButtonClick()}> Lab </Button>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <div >{this.dropDownLab()}</div>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <div >{this.dropDownDoctor()}</div>
                    </Col>
                    </Row>
                </Header>
            </>
        )
    }

    footerView = () => {
        return (
            <Footer style ={{backgroundColor : 'lightgrey'}}>
                Footer
            </Footer>
        )
    }
    
    patientFormView = () => {
        return(
            <Form style={{marginTop: "10px", marginLeft: "10px"}}>
                        
                <Form.Item label="Mr/s" required >
                    <Select onChange = {this.onGenderSelect} value = {this.store.patientDetails.gender} defaultValue="Mr" disabled={this.store.patientDetails.isExistingPatient} style={{width : 100}} >
                        <Option value="M">Mr</Option>
                        <Option value="F">Mrs</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Name" required> 
                    {
                        this.store.patientDetails.isExistingPatient ? 
                        <Input required placeholder="Enter Name"  value ={this.store.patientDetails.name} disabled='true'  style={{width : 200}} />
                        :
                        <Input required placeholder="Enter Name"  onKeyUp={this.onSearchPatientSuggestedList} style={{width : 200}} />
                    }
                </Form.Item>
       
                <Form.Item label="Gender" >
                    <Radio.Group disabled={this.store.patientDetails.isExistingPatient} onChange={this.onGenderRadioSelection} value={this.store.patientDetails.gender}>
                        <Radio value='M'>Male</Radio>
                        <Radio value='F'>Female</Radio>
                    </Radio.Group>
                </Form.Item> 
                <Form.Item label="Date Of Birth" required>
                    
                    {
                        this.store.patientDetails.isExistingPatient
                        ? <text> {this.store.patientDetails.dob} </text>
                        : <DatePicker onChange={this.onDobSelected} />
                    }
                </Form.Item>
                <Form.Item label="Age" >
                    <div> 
                        {this.store.patientAge}
                    </div>
                </Form.Item>
                <Form.Item label = "Address" >
                <TextArea  allowClear onChange={this.onAddressEntered} />
  
                </Form.Item>
                <Form.Item >
                    <Button type="primary" style={{float:'right'}}>Submit</Button>
                </Form.Item>   
            </Form>
        )
    }

    testInfoView = () => {
        return (
            <div style={{marginTop: "5px", marginLeft: "5px"}}>
            <Input  placeholder="Search for Tests"  onKeyUp={ this.onSearchTestSuggestedList } />
                <div className="ag-theme-alpine" style={{marginTop: "5px"}} >
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={this.defaultColDef}
                        rowData={this.store.selectedTestList}
                        columnDefs={this.columnDefsTest}
                        rowSelection={'single'}
                        onRowClicked={this.deleteSelectedTestFromList}
                        domLayout='autoHeight'                
                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }

    gridRef = React.createRef();

    defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
    };

    columnDefsTest = [
        { headerName: 'Test Name', field: 'name', pinned: 'left', width: 200 },
        { headerName: 'Sample Type', field: 'sampleType', filter: 'agTextColumnFilter', pinned: 'left', width: 200 },
        { headerName: 'Price', field: 'price', editable: false, filter: 'agNumberColumnFilter', width: 100 }
    ];
    

    columnDefsPatient = [
        { headerName: 'Patient Name', field: 'name', pinned: 'left', width: 200 },
        { headerName: 'Age', field: 'age', filter: 'agTextColumnFilter', pinned: 'left', width: 100 },
        { headerName: 'Address', field: 'address', editable: false, filter: 'agNumberColumnFilter', width: 10 }
    ];

    suggestedPatientsAgGrid = () => {
        return (
            <div className="ag-theme-alpine"  style={{height : '30vh'}}>
                <AgGridReact 
                    ref={this.gridRef}
                    defaultColDef={this.defaultColDef}
                    rowData={this.store.suggestedPatientResults}
                    columnDefs={this.columnDefsPatient}
                    rowSelection={'single'}
                    onRowClicked={this.onSuggestedPatientSelect}
                    domLayout='autoHeight' 
                >
                </AgGridReact>
            </div>  
        )
    }

    suggestedTestsAgGrid = () => {
        console.log(this.store.suggestedTestResults);
        return (  
            <div className="ag-theme-alpine"  >
                <AgGridReact
                    ref={this.gridRef}
                    defaultColDef={this.defaultColDef}
                    rowData={this.store.suggestedTestResults}
                    columnDefs={this.columnDefsTest}
                    rowSelection={'single'}
                    onRowClicked={this.onSuggestedTestSelect}
                    domLayout='autoHeight'            
                >
                </AgGridReact>
            </div>   
        )
    }

    existingPatientView = () => {
        if (this.store.patientDetails.isExistingPatient) {
            return (
                <Header style={{height: '10vh',backgroundColor: "#d8dbcc"}}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={6}>                     
                            <div > {this.store.patientDetails.gender} </div>              
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div >
                                {this.store.patientDetails.name}
                            </div>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div >{ this.store.patientDetails.age }</div>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div >{this.store.patientDetails.address}</div>
                        </Col>
                    </Row>
                </Header>
            )
        }

        return null;
    }

    render() {
        return (     
            <>
            <div>
                <PageHeader title={pageTitle("Bookings")}></PageHeader>
                {this.patientSourceView()}
                {this.existingPatientView()}
                
                <Layout style={{height:"70vh",marginTop : "10px"}}>
                    <Content>
                        {
                            this.store.patientDetails.isExistingPatient
                            ? this.suggestedTestsAgGrid()
                            : this.suggestedPatientsAgGrid()
                        }
                    </Content>
                    <Sider style={{backgroundColor: "#d8dbcc"}} width="50%">
                        {
                            this.store.patientDetails.isExistingPatient
                            ? this.testInfoView()
                            : this.patientFormView()
                        }
                    </Sider>
                </Layout>
                {this.footerView()}
            </div>
            </>
        )
    }
}
export default observer(PatientTestUI)